import { rsvpService } from './rsvpService';

export const exportService = {
  async exportRSVPToCSV(inviteCode: string, userId: string, selectedFields?: string[]): Promise<string> {
    const rsvps = await rsvpService.getRSVPsByInviteCode(inviteCode, userId);

    const allFieldsMap: Record<string, { label: string; getValue: (rsvp: any) => string }> = {
      guestName: {
        label: '賓客姓名',
        getValue: (rsvp) => rsvp.guestName
      },
      guestSide: {
        label: '親友分類',
        getValue: (rsvp) => rsvp.guestSide === 'bride' ? '女方親友' : '男方親友'
      },
      guestEmail: {
        label: '電子郵件',
        getValue: (rsvp) => rsvp.guestEmail
      },
      contactPhone: {
        label: '聯絡電話',
        getValue: (rsvp) => rsvp.rsvpData.contactPhone || ''
      },
      attending: {
        label: '出席狀態',
        getValue: (rsvp) => rsvp.rsvpData.attending === 'yes' ? '出席' : '不出席'
      },
      guestCount: {
        label: '人數',
        getValue: (rsvp) => rsvp.rsvpData.guestCount.toString()
      },
      specialRequests: {
        label: '特殊需求',
        getValue: (rsvp) => (rsvp.rsvpData.dietaryRestrictions || []).map((dr: any) => `${dr.id}:${dr.count}`).join(';')
      },
      message: {
        label: '留言',
        getValue: (rsvp) => rsvp.rsvpData.specialRequests || rsvp.rsvpData.message || ''
      },
      submittedAt: {
        label: '提交時間',
        getValue: (rsvp) => rsvp.submittedAt.toLocaleString('zh-TW')
      }
    };

    const fieldsToExport = selectedFields && selectedFields.length > 0
      ? selectedFields
      : Object.keys(allFieldsMap);

    const headers = fieldsToExport.map(fieldKey => allFieldsMap[fieldKey]?.label || fieldKey);

    const rows = rsvps.map(rsvp =>
      fieldsToExport.map(fieldKey => allFieldsMap[fieldKey]?.getValue(rsvp) || '')
    );

    const csvContent = [headers, ...rows]
      .map(row => row.map(cell => `"${cell.replace(/"/g, '""')}"`).join(','))
      .join('\n');

    return csvContent;
  }
};
